import { Component, ViewChild } from '@angular/core';
import { ApiService } from '../../core/services/api.service';
import { Load } from '../../Models/load';
import { LoadConfigurationDetailComponent } from '../load-configuration-detail/load-configuration-detail.component';
import { HttpParams } from '@angular/common/http';
import { LoadDto } from '../../dtos/load-dto';
import { DataTableComponent } from '../../shared/data-table/data-table.component';


@Component({
    selector: 'load-configuration',
    templateUrl: './load-configuration.component.html',
    styleUrls: ['./load-configuration.component.scss']
})

export class LoadConfigurationComponent {
  search: any;
  displayedColumns: string[] = ['id', 'registerDate', 'status', 'plant', 'action'];
  @ViewChild("tableChild") tableChild: DataTableComponent<LoadDto>;
  loads: LoadDto[] = [];
  searchText: string = '';
  selectedLoad: LoadDto;
  openAside: boolean = false;
  initDate: Date;
  endDate: Date;
  start: number = 0;
  pageSIze: number = 5;
  totalLoads: number = 0;
  pagePath: string = 'api/load/GetByPage';
  options = {
    columnTitles: ["LOAD_CONFIGURATION.LABELS.TABLE.ID", "LOAD_CONFIGURATION.LABELS.TABLE.DATE", /*"LOAD_CONFIGURATION.LABELS.TABLE.STATUS",
      "LOAD_CONFIGURATION.LABELS.TABLE.PLANT",*/ "GENERAL.LABELS.ACTIONS"],
    columnReferences: ["id", 'registerDate',/* "Incompleto", "Monterrey",*/ "actions"],
    actionButtons: { detail: true }
  };

  @ViewChild(LoadConfigurationDetailComponent) asideDetail: LoadConfigurationDetailComponent;

  constructor(private apiService: ApiService) {
    this.initDate = new Date();
    this.initDate.setMonth(this.initDate.getMonth() - 1);
    this.endDate = new Date();
    //this.getTotalLoads();
    //this.getLoads(this.start, this.pageSIze);
  }

  getLoads(start: number, pageSize: number) {
    let params: HttpParams = new HttpParams();
    params = params.append("start", start.toString());
    params = params.append("pageSize", pageSize.toString());
    if (this.searchText) {
      params = params.append("search", this.searchText);
    }
    if (this.initDate) {
      params = params.append("initDate", new Date(this.initDate).toISOString());
    }
    if (this.endDate) {
      params = params.append("endDate", new Date(this.endDate).toISOString());
    }
    this.apiService.get<any>("api/load/GetByPage", params).subscribe((response: any) => {
      if (response) {
        this.loads = response.data;
      }
    }, error => {
      console.log(error);
      });
  }

  getTotalLoads() {
    let params: HttpParams = new HttpParams();
    if (this.searchText) {
      params = params.append("search", this.searchText);
    }
    if (this.initDate) {
      params = params.append("initDate", new Date(this.initDate).toISOString());
    }
    if (this.endDate) {
      params = params.append("endDate", new Date(this.endDate).toISOString());
    }
    this.apiService.get<any>("api/load/GetTotalLoads", params).subscribe((response: any) => {
      if (response) {
        this.totalLoads = response.data;
      }
    }, error => {
      console.log(error);
    });
  }

  openDetail(load: LoadDto) {
    this.selectedLoad = load;
    this.openAside = true;
    setTimeout(() => {
      this.asideDetail.open();
    });
  }

  moreLoads(event: any) {
    this.start = event.pageIndex;
    if (event.pageIndex > this.start) {
      this.start++
      this.getLoads(this.start, this.pageSIze);
    }
  }

  searchLoad() {
    this.search = {
      searchText: this.searchText,
      initDate: this.initDate,
      endDate: this.endDate
    }
    this.tableChild.firstPage();
    this.tableChild.loadPage(this.search);
    //this.loads = [];
    //this.getTotalLoads();
    //this.getLoads(this.start, this.pageSIze);
  }


}
